var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "default-page" }, [
    _c("div", { ref: "swiperContainer", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-container-box" },
        [
          _c("scroll-list", {
            attrs: { "scroll-list": _vm.bannerImgs },
            on: { afterLoaded: _vm.afterLoadedScroll }
          })
        ],
        1
      )
    ]),
    _c("div", [_c("nuxt")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314f53c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314f53c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/default.vue
// module id = DLCH
// module chunks = 7